module.exports = __webpack_public_path__ + "media/src/assets/Images/BottomArrow-8179ebfc82e2e6f1ca61323b737a523e.svg";